import * as service from "../service";
import { store } from "../../store";

export interface UserSociety {
  membership_id: string;
  id: string;
  name: string;
  icon: string | null;
  description: string | null;
  university: string | null;
  /**
   * Bare official handle, normalised by the API because `instagram_url` holds a
   * full URL on scraped rows and a bare handle on registered ones.
   */
  instagram_handle: string | null;
  /** Absolute profile URL rebuilt from the handle, for link surfaces. */
  instagram_profile_url: string | null;
  instagram_url: string | null;
  chop_image_url: string | null;
}

/**
 * Fetch the societies the current student has joined.
 * Backend: GET /api/society/getUserSocieties
 */
export const GetUserSocietiesAPI = async (): Promise<UserSociety[]> => {
  const { student } = store.getState().auth as any;
  try {
    const resp = await service.call("GET", "api/society/getUserSocieties", {
      user_id: student?.id,
    });
    if (resp?.status === 0 && Array.isArray(resp.result)) {
      return resp.result as UserSociety[];
    }
    return [];
  } catch (err) {
    console.error(`GetUserSocietiesAPI ${err}`);
    return [];
  }
};

/**
 * Fetch the societies the current student has requested to join but which are
 * not verified yet.
 * Backend: GET /api/society/getUserSocieties
 */
export const GetPendingSocietiesAPI = async (): Promise<UserSociety[]> => {
  const { student } = store.getState().auth as any;
  try {
    const resp = await service.call("GET", "api/society/getUserSocieties", {
      user_id: student?.id,
    });
    if (resp?.status === 0 && Array.isArray(resp.pending)) {
      return resp.pending as UserSociety[];
    }
    return [];
  } catch (err) {
    console.error(`GetPendingSocietiesAPI ${err}`);
    return [];
  }
};
